import { DUPLICATE_VO } from './duplicateVO';
import { UPDATE_PAYMENT_TYPE } from './updatePaymentType';
import { UPDATE_CURRENT_STAGE } from './updateCurrentStage';
import { GET_CALCULATED_REVENUE } from './getCalculatedRevenue';
import { GET_VO_PROPOSALS_OPTIONS } from './getVOProposalsOptions';
import { UPDATE_VENDOR_OPPORTUNITY } from './updateVendorOpportunity';
import { UPDATE_EQUIPMENT_CONDITION } from './updateEquipmentCondition';
import { UPDATE_ESTIMATED_CLOSE_DATE } from './updateEstimatedCloseDate';
import { Q_GET_DEAL_INFO_FROM_EXTERNAL_DMS } from './getDealInfoFromExternalDms';
import { UPSERT_VENDOR_OPPORTUNITY_REVENUE } from './upsertVendorOpportunityRevenue';
import { GET_VENDOR_OPPORTUNITY_REVENUE_BREAKDOWN } from './getVendorOpportunityRevenueBreakdown';
import { UPSERT_VENDOR_OPPORTUNITY_REVENUE_FROM_CALCULATIONS } from './upsertVendorOpportunityRevenueFromCalculations';

export const VOApi = {
  duplicate: DUPLICATE_VO,
  update: UPDATE_VENDOR_OPPORTUNITY,
  updatePaymentType: UPDATE_PAYMENT_TYPE,
  updateCurrentStage: UPDATE_CURRENT_STAGE,
  updateEquipmentCondition: UPDATE_EQUIPMENT_CONDITION,
  updateEstimatedCloseDate: UPDATE_ESTIMATED_CLOSE_DATE,

  fetchProposalOptions: GET_VO_PROPOSALS_OPTIONS,
  getDealInfoFromExternalDms: Q_GET_DEAL_INFO_FROM_EXTERNAL_DMS,

  getCalculatedRevenue: GET_CALCULATED_REVENUE,
  upsertVendorOpportunityRevenue: UPSERT_VENDOR_OPPORTUNITY_REVENUE,
  upsertVendorOpportunityRevenueFromCalculations: UPSERT_VENDOR_OPPORTUNITY_REVENUE_FROM_CALCULATIONS,
  getVendorOpportunityRevenueBreakdown: GET_VENDOR_OPPORTUNITY_REVENUE_BREAKDOWN,
};
